import React from 'react';
import { useRef } from 'react';
import { Button, withStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import translate from '../../locales';
import { connect } from 'react-redux';
import { styleWithCommonClasses } from '../../_constants/emparkConstants';
import { useState } from 'react';
import CellTextTable from '../Tables/CellTextTable';
import { regexRules } from '../../_helpers/utility';


const __t = translate;

const styles = styleWithCommonClasses({
  buttonCancel: {
    '& span': {
      color: '#7b7c7d'
    }
  },
  error: {
    marginBottom: 10,
    textAlign: 'center',
    color: 'red',
  },
  tableContainer: {
    maxHeight: '40vh',
    overflowY: 'auto',
  }
})

const ValueListDialog = props => {
  const { title, classes } = props;

  const [error, setError] = useState(null);

  const tableSubmitRef = useRef(null);

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={props.open || false}
      onClose={props.onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        {error && <div className={classes.error}>{error}</div>}

        <div className={classes.tableContainer}>
          <CellTextTable
            refReturnData={(returnData) => { tableSubmitRef.current = returnData }}
            values={props.values}
            type="text"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button className={classes.buttonCancel} variant="outlined" color="primary" onClick={props.onCancel}>
          {__t('cancel')}
        </Button>
        <Button variant="outlined" color='primary' onClick={() => {
          const values = tableSubmitRef.current();
          const uniqueArray = [...new Set(values.map(v => v.trim()))];

          if (uniqueArray.length != values.length) {
            setError(__t('error_duplicate_values'));
            return;
          }

          if (uniqueArray.some(v => !v)) {
            setError(__t('error_empty_values'));
            return;
          }

          if (uniqueArray.some(v => !regexRules.alphanumericUnderscore.test(v))) {
            setError(__t('error_only_alphanumeric_underscore'));
            return;
          }

          props.onSubmit(uniqueArray);
        }}
        >
          {__t('accept')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

function mapStateToProps(state) {
  return {

  }
}


function mapDispatchToProps(dispatch) {
  return {

  }
}

ValueListDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  values: PropTypes.array,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(ValueListDialog));